<template>
  <div class="company">
    <div class="companyContainer">
      <div class="company-detail">
        <div class="company-follow">
          <h1 class="company-top">
            {{ companyDetail.reCompanyName }}
          </h1>
          <bytedance-button
            @click="getDoCompanyCollect"
            size="large"
            :class="[hide ? 'follow' : '']"
            >{{ hide ? "已关注" : "关注" }}</bytedance-button
          >
        </div>
        <div class="company-detail-subTitle">
          <span class="tag" v-if="companyDetail.industry">{{
            companyDetail.industry
          }}</span
          ><span class="tag" v-if="companyDetail.enterpriseNature">{{
            companyDetail.enterpriseNature
          }}</span
          ><span class="tag" v-if="companyDetail.enterpriseScale">{{
            companyDetail.enterpriseScale
          }}</span>
          <span class="tag" v-if="companyDetail.groupName">{{
            companyDetail.groupName
          }}</span>
        </div>
        <div
          class="company-detail-description company-detail-block"
          v-if="companyDetail.reCompanyInfo"
        >
          <h2>公司描述</h2>
          <pre class="textContent" v-html="companyDetail.reCompanyInfo"></pre>
        </div>
        <div class="company-list">
          <h2>招聘职位</h2>
          <ul class="content-list">
            <li
              class="recommend-job-item"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <a :href="'/jobDetail/' + item.jobId" target="_blank">
                <div class="job-top-container">
                  <div class="job-top">
                    <h3 class="job-name substring">{{ item.job }}</h3>
                    <h3 class="wage substring">{{ item.startSalary }}</h3>
                  </div>
                  <div class="job-bottom substring">
                    <span class="tag" v-if="item.workingPlace">{{
                      item.workingPlace
                    }}</span
                    ><span class="tag" v-if="item.educationName">{{
                      item.educationName
                    }}</span
                    ><span class="tag" v-if="item.serviceName">{{
                      item.serviceName
                    }}</span>
                  </div>
                  <div class="job-bottom substring">
                    <span
                      v-for="(ite, i) in item.disabilities"
                      class="block"
                      :style="{ backgroundColor: getTagColor(ite) }"
                      >{{ ite }}</span
                    >
                  </div>
                </div>
              </a>
              <div class="company-bottom">
                <div class="company-desc">
                  <a
                    :href="'/companyDetail/' + item.companyId"
                    target="_blank"
                    class="company-t"
                  >
                    <img
                      v-if="item.reCompanyLogo"
                      :src="item.reCompanyLogo"
                      alt=""
                      class="company-logo"
                    />
                    <div
                      v-else
                      class="company-title"
                      :style="{ backgroundColor: getColorById(item.companyId) }"
                    >
                      {{ item.companyName.slice(0, 4) }}
                    </div>
                    <div class="company-name substring">
                      {{ item.companyName }}
                    </div>
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <!-- 分页器 -->
          <div class="pagination-wrapper">
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryFilter.params.pageNum"
              :limit.sync="queryFilter.params.pageSize"
              @pagination="jobList"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCompany,
  getJobsList,
  getPreviewUrl,
  getDisabledStatus,
  isCompanyCollected,
  doCompanyCollect,
} from "@/api/index.js";
import {
  getTagColor,
  getColorById,
  formatDisabilityData,
} from "@/helper/utilities";
import { groupBy } from "lodash";
import { getToken } from "@/helper/auth";
export default {
  name: "companyDetail",
  data() {
    return {
      companyDetail: {},
      dataList: [],
      // 总条数
      total: 0,
      queryFilter: {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
        companyId: "",
      },
      hide: false,
    };
  },
  created() {
    this.queryFilter.companyId = this.$route.params.id;
    this.getCompanyDetail();
    this.jobList();
  },
  methods: {
    getTagColor,
    getColorById,
    //公司详情
    getCompanyDetail() {
      getCompany(this.queryFilter.companyId)
        .then((res) => {
          this.companyDetail = res.data;
          this.getIsCompanyCollected(res.data.reCompanyId);
        })
        .catch(() => {});
    },

    //查询公司是否关注
    getIsCompanyCollected(reCompanyId) {
      if (getToken()) {
        isCompanyCollected(reCompanyId)
          .then((res) => {
            if (res.code == 200) {
              this.hide = res.data;
            }
          })
          .catch(() => {});
      }
    },

    //关注公司
    getDoCompanyCollect() {
      if (getToken()) {
        doCompanyCollect(this.queryFilter.companyId)
          .then((res) => {
            if (res.code == 200) {
              this.getIsCompanyCollected(this.queryFilter.companyId);
            }
          })
          .catch(() => {});
      } else {
        this.$router.push({ path: "/user" });
      }
    },

    //岗位列表
    jobList() {
      const loading = this.$loading();
      getJobsList(this.queryFilter)
        .then(async (res) => {
          loading.close();
          // 1. 提取所有 jobId
          let jobIds = res.data.map((item) => item.jobId);
          // 2. 根据 jobIds 异步获取残疾标签数据
          await this.fetchDisabilityLabels(res.data, jobIds);
          this.total = res.total;
        })
        .catch(() => {
          loading.close();
        });
    },

    //3，获取对应数据的残疾标签
    fetchDisabilityLabels(dataList, jobIds) {
      if (jobIds.length > 0) {
        getDisabledStatus(jobIds).then((res) => {
          const result = {};
          Object.keys(res.data).forEach((jobId) => {
            const grouped = groupBy(res.data[jobId], "disabledType");
            result[jobId] = Object.entries(grouped).map(([type, items]) => ({
              disabledType: type,
              disabledLevel: [
                ...new Set(items.map((item) => item.disabledLevel)),
              ],
            }));
          });

          const formattedData = formatDisabilityData(result);
          this.dataList = dataList.map((job, i) => {
            if (job.reCompanyLogo) {
              this.PreviewLogoUrl(job.reCompanyLogo, i);
            }
            // 找到当前jobId对应的残疾数据
            const disabilities = formattedData[job.jobId] || [];
            return {
              ...job,
              disabilities, // 将残疾数据添加到职位对象中
            };
          });
        });
      } else {
        this.dataList = [];
      }
    },

    //获取岗位列表公司logo
    async PreviewLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.dataList[i].reCompanyLogo = response.msg;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.company {
  background-color: #f3f3f3;
  padding-bottom: 30px;
  .companyContainer {
    width: @main-width;
    margin: auto;
    padding-top: 50px;
    line-height: 2em;
    .company-detail {
      width: @main-width;
      padding: 40px;
      background: #fff;
      box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
      border-radius: 8px;
      .company-follow {
        display: flex;
        justify-content: center;
        align-items: center;
        .bytedance-button {
          width: 150px;
          background: #fff;
          color: #00a0e9;
          border: 2px solid #00a0e9;
          font-weight: 800;
        }
        .follow {
          background-color: #585857;
          color: #ffffff;
          border: 0;
        }
        .company-top {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          text-align: left;
          width: 100%;
        }
      }
      &-subTitle {
        font-size: @font-size-base;
        color: @primary-text-color;
        margin: 20px 0;
        .tag:not(:first-child):before {
          content: "|";
          margin: 0 4px;
        }
      }
      &-description {
        .textContent {
          white-space: pre-line;
        }
      }
      &-block {
        h2 {
          margin-bottom: 20px;
        }
        margin: 40px 0;
        .textContent {
          font-size: @font-size-base;
          color: @primary-text-color;
        }
      }

      .recommend-job-item {
        background-color: #fafbfd;
        box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
        border-radius: 8px;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        margin-bottom: 21px;
        padding: 13px 25px;
        width: @main-width;
      }
      .pagination-wrapper {
        text-align: center;
      }
    }
  }
}
</style>
